var _defs, _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg0(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 101",
    width: 300,
    height: 101,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "get-it-on-google-play-logo-svg-vector") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(15.09,26.593,-31.197,17.703,23.68,52.461)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff177b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffec73"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g2",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-10.421,75.062,-45.783,-6.356,30.962,17.204)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#064aa2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#63ffd4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g3",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-36.121,26.065,-23.708,-32.854,40.35,46.538)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8a33db"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g4",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(22.212,31.982,-15.637,10.86,18.553,27.915)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a3b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d6ffa1"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #ffffff } \n\t\t.s1 { fill: url(#g1) } \n\t\t.s2 { fill: url(#g2) } \n\t\t.s3 { fill: none } \n\t\t.s4 { fill: url(#g3) } \n\t\t.s5 { fill: url(#g4) } \n\t\t.s6 { fill: #000000 } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Play-Store"
  }, /*#__PURE__*/React.createElement("path", {
    id: "background",
    className: "s0",
    d: "m12.4 0h275.3c6.7 0 12.1 5.4 12.1 12.1v76.8c0 6.7-5.4 12.1-12.1 12.1h-275.3c-6.7 0-12.2-5.4-12.2-12.1v-76.8c0-6.7 5.5-12.1 12.2-12.1z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "orange",
    className: "s1",
    d: "m36.8 48.5c0 0-20.7-11.4-21.9-12.1-1.2-0.7-2.5-0.2-2.5 1.1v49.3c0 1 0.9 1.4 2 0.9 1-0.6 22.4-12.4 22.4-12.4 0 0 2.9-1.6 4.3-2.4 2.3-1.3 7-3.9 7-3.9 0 0 9.6-5.3 10.9-6 1.3-0.7 1.2-1.7 0.1-2.2-1.1-0.5-11-6.1-11-6.1z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "blue"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-3_1_",
    className: "s2",
    d: "m40.6 61.8l-27.2-25.6c-0.6 0.1-1 0.6-1 1.4v49.1c0 0.7 0.2 1.1 0.6 1.2z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    className: "s3",
    d: "m48.1 54.8l-11.4-6.3c0 0.1-20.7-11.3-21.9-11.9-1.2-0.8-2.4-0.4-2.4 1v49.3c0 1.1 0.8 1.5 1.8 1 1.2-0.6 22.5-12.4 22.5-12.5l11.4-6.3c-0.1 0.1 9.5-5.2 10.7-5.9 1.4-0.7 1.3-1.7 0.2-2.2-1.1-0.6-11-6.1-10.9-6.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "red"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-7",
    className: "s4",
    d: "m36.7 48.5c0 0.1-20.7-11.3-21.9-11.9-1.2-0.8-2.4-0.4-2.4 1v49.3c0 1.1 0.8 1.5 1.8 1 1.2-0.6 22.5-12.4 22.5-12.5l11.4-6.3c-0.1 0.1 9.5-5.2 10.7-5.9 1.4-0.7 1.3-1.7 0.2-2.2-1.1-0.6-11-6.1-10.9-6.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "green"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-9_1_",
    className: "s5",
    d: "m14.8 36.4q-0.8-0.4-1.4-0.2l27.2 25.7 7.5-7.1-11.3-6.3c0 0-10.7-5.9-17.2-9.5z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill-4",
    className: "s3",
    d: "m48.1 54.8l-11.4-6.3c0 0.1-20.7-11.3-21.9-11.9-1.2-0.8-2.4-0.4-2.4 1v49.3c0 1.1 0.8 1.5 1.8 1 1.2-0.6 22.5-12.4 22.5-12.5l11.4-6.3c-0.1 0.1 9.5-5.2 10.7-5.9 1.4-0.7 1.3-1.7 0.2-2.2-1.1-0.6-11-6.1-10.9-6.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Google-play"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1_1_",
    className: "s6",
    d: "m205.4 70.5l-2.2 2.1c-0.6 0.3-1.1 0.7-1.6 0.9-1.5 0.7-3.1 0.9-4.5 0.9-1.5 0-3.9-0.1-6.3-1.9-3.3-2.3-4.8-6.4-4.8-9.9 0-7.3 6-10.9 10.8-10.9 1.7 0 3.4 0.5 4.8 1.3 2.4 1.6 3 3.6 3.3 4.7l-11 4.5-3.6 0.3c1.1 5.9 5.2 9.4 9.6 9.4 2.3 0 3.9-0.7 5.4-1.5 0 0 0.4-0.1 0.1 0.1zm-6.7-12c0.9-0.3 1.3-0.6 1.3-1.3 0-1.9-2.1-4.1-4.6-4.1-1.8 0-5.3 1.5-5.3 6.6 0 0.8 0.1 1.7 0.1 2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-2",
    className: "s6",
    d: "m182.4 70.2c0 1.9 0.3 2.1 1.8 2.3 0.9 0.1 1.7 0.1 2.4 0.2l-1.7 1h-8.2c1-1.4 1.2-1.5 1.2-2.4v-1.1-27.9h-3.6l3.5-1.7h6.7c-1.5 0.9-1.9 1.4-2.1 3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-3",
    className: "s6",
    d: "m169.6 54c1.1 0.9 3.3 2.8 3.3 6.4 0 3.4-2 5.1-3.9 6.6-0.6 0.6-1.3 1.3-1.3 2.3 0 1.1 0.7 1.6 1.2 2.1l1.7 1.3c2 1.7 3.9 3.3 3.9 6.5 0 4.4-4.3 8.9-12.3 8.9-6.8 0-10.1-3.2-10.1-6.7 0-1.7 0.9-4.1 3.6-5.7 2.9-1.8 6.9-2 9-2.2-0.7-0.8-1.4-1.7-1.4-3.2 0-0.8 0.2-1.3 0.4-1.8-0.5 0-1 0.1-1.5 0.1-4.9 0-7.7-3.7-7.7-7.4 0-2.2 1-4.5 3-6.3 2.6-2.2 5.8-2.6 8.3-2.6h9.7l-3 1.7zm-3.3 20.8c-0.4 0-0.6 0-1.1 0-0.4 0-3 0.1-4.9 0.7-1.1 0.4-4.1 1.6-4.1 5 0 3.4 3.3 5.8 8.3 5.8 4.5 0 6.9-2.2 6.9-5.1 0-2.5-1.5-3.8-5.1-6.4zm1.3-9c1.1-1.1 1.2-2.6 1.2-3.4 0-3.4-2-8.6-5.9-8.6-1.2 0-2.5 0.6-3.2 1.5-0.8 1-1.1 2.3-1.1 3.5 0 3.1 1.9 8.3 5.9 8.3 1.1 0 2.4-0.6 3.1-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-4_1_",
    className: "s6",
    d: "m140.4 74.4c-7.4 0-11.4-5.9-11.4-11.2 0-6.2 5-11.5 12.2-11.5 6.8 0 11.2 5.5 11.2 11.2 0 5.6-4.3 11.5-12 11.5zm5.9-3.9c1.1-1.5 1.4-3.4 1.4-5.2 0-4.2-2-12.2-7.8-12.2-1.6 0-3.1 0.7-4.3 1.7-1.8 1.6-2.1 3.7-2.1 5.7 0 4.7 2.3 12.4 8 12.4 1.8 0 3.7-0.8 4.8-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-5",
    className: "s6",
    d: "m115.5 74.4c-7.5 0-11.4-5.9-11.4-11.2 0-6.2 5-11.5 12.1-11.5 6.9 0 11.2 5.5 11.2 11.2 0 5.6-4.3 11.5-11.9 11.5zm5.8-3.9c1.2-1.5 1.4-3.4 1.4-5.2 0-4.2-2-12.2-7.8-12.2-1.5 0-3.1 0.7-4.2 1.7-1.9 1.6-2.2 3.7-2.2 5.7 0 4.7 2.3 12.4 8 12.4 1.9 0 3.7-0.8 4.8-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-6",
    className: "s6",
    d: "m101 73l-6.3 1.4c-2.6 0.4-4.9 0.8-7.3 0.8-12.2 0-16.8-9-16.8-16 0-8.6 6.6-16.6 17.8-16.6 2.4 0 4.7 0.4 6.8 1 3.3 0.9 4.8 2 5.8 2.7l-3.7 3.5-1.5 0.4 1.1-1.8c-1.5-1.5-4.3-4.2-9.5-4.2-6.9 0-12.2 5.3-12.2 13.1 0 8.3 6 16.1 15.6 16.1 2.8 0 4.3-0.6 5.6-1.1v-7.1l-6.6 0.3 3.5-1.9h9.4l-1.2 1.1c-0.3 0.3-0.3 0.4-0.4 0.8-0.1 0.4-0.1 1.6-0.1 2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-7_1_",
    className: "s6",
    d: "m219 70.7v11.9h-2.3v-30.3h2.3v3.4c1.6-2.2 4.4-4 7.7-4 5.9 0 9.8 4.5 9.8 11.5 0 7.1-3.9 11.6-9.8 11.6-3.1 0-5.9-1.6-7.7-4.1zm15.1-7.3c0-5.3-2.8-9.4-7.7-9.4-3.1 0-6 2.4-7.3 4.5v9.8c1.3 2.1 4.2 4.6 7.3 4.6 4.9 0 7.7-4.1 7.7-9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-8",
    fillRule: "evenodd",
    className: "s6",
    d: "m242.2 43.9v30.5h-2.4v-30.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-9",
    className: "s6",
    d: "m268.7 80.5c0.5 0.3 1.4 0.4 1.9 0.4 1.5 0 2.5-0.6 3.4-2.7l1.7-3.9-9.3-22.2h2.6l8 19.3 8-19.3h2.7l-11.4 26.9c-1.2 2.7-3.1 4.1-5.6 4.1-0.8 0-1.8-0.2-2.4-0.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-10",
    className: "s6",
    d: "m262 74.3q-0.3-1.1-0.4-2-0.1-0.8-0.1-1.7-1.2 1.8-3.5 3c-1.4 0.8-2.9 1.2-4.8 1.2q-3.5 0-5.4-1.8-1.9-1.7-1.9-4.7 0-2.9 2.8-4.8 2.8-1.8 7.2-1.8h5.6v-2.8q0-2.4-1.6-3.7-1.7-1.4-4.6-1.4-2.7 0-4.4 1.3-1.6 1.2-1.7 3.1h-2.4v-0.2c-0.1-1.6 0.6-3.1 2.3-4.4q2.4-1.9 6.3-1.9 3.9 0 6.3 1.9 2.4 1.9 2.4 5.4v10.9q0 1.1 0.1 2.3 0.2 1.1 0.5 2.1zm-8.5-1.6c2.1 0 3.5-0.4 5-1.3q2.2-1.4 3-3.5v-4.2h-5.6q-3.2-0.1-5.3 1.4-2.1 1.4-2.1 3.4 0 1.9 1.4 3.1 1.3 1.1 3.6 1.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Get-it-on"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1_2_",
    className: "s6",
    d: "m69.8 23.3c0-4.3 3.5-7.2 7.8-7.2 2.9 0 4.8 1.3 6 2.9l-2.1 1.1c-0.8-1-2.2-1.8-3.9-1.8-2.9 0-5.1 2.1-5.1 5 0 2.9 2.2 5 5.1 5 1.5 0 2.9-0.7 3.5-1.3v-2.1h-4.4v-2.1h7v5.1c-1.4 1.5-3.5 2.6-6.1 2.6-4.3 0-7.8-2.9-7.8-7.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-2_1_",
    className: "s6",
    d: "m87.1 30.3v-13.9h10.4v2.1h-7.7v3.6h7.5v2.1h-7.5v3.9h7.7v2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-3_1_",
    className: "s6",
    d: "m104.5 30.3v-11.8h-4.5v-2.1h11.7v2.1h-4.5v11.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-4_2_",
    fillRule: "evenodd",
    className: "s6",
    d: "m123.5 16.4v13.9h-2.5v-13.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-5_1_",
    className: "s6",
    d: "m130.8 30.3v-11.8h-4.5v-2.1h11.6v2.1h-4.5v11.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-6_1_",
    className: "s6",
    d: "m146.6 23.3c0-4.1 3.2-7.1 7.7-7.1 4.5 0 7.7 3 7.7 7.1 0 4.1-3.2 7.2-7.7 7.2-4.5 0-7.7-3.1-7.7-7.2zm12.7-0.1c0-2.8-2-5-5-5-3.1 0-5 2.2-5 5 0 2.8 1.9 4.9 5 4.9 3 0 5-2.1 5-4.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-7_2_",
    className: "s6",
    d: "m175.3 30.3l-7.7-10v10h-2.6v-13.9h2.6l7.6 9.6v-9.6h2.7v13.9z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg0);
export default __webpack_public_path__ + "static/media/0.25e60cb54b56d73eee91502677f56795.svg";
export { ForwardRef as ReactComponent };